import { gql } from '@apollo/client';

export const ROTATIONSPLAN_AKTIVIERT_BY_STANDORTGRUPPEN_ID = gql(`
  query rotationsplanAktiviertByStandortGruppenId($standortGruppenId: String!) {
   navigation_standortgruppeById(standortGruppenId: $standortGruppenId) {
      id
      istRotationsplanAktiviert
    }
  }
`);
